module.exports = __webpack_public_path__ + "img/no-notes.702bafca.png";